import { Component } from '@angular/core';

import { TranslatePipe } from '@camelot/translation';

import { CamTranslationGrid } from '../../translation.service';
import { AbstractHeaderComponent } from '../abstract';
import { BaseHeaderComponent } from '../base-header/base-header.component';

@Component({
  selector: 'cam-custom-header',
  templateUrl: './custom-header.component.html',
  styleUrl: './custom-header.component.scss',
  imports: [BaseHeaderComponent, TranslatePipe],
})
export class CustomHeaderComponent extends AbstractHeaderComponent<any, any> {
  constructor() {
    super();
    CamTranslationGrid.getInstance();
  }
}
